import { useQuery } from '@tanstack/react-query';
import { ApexOptions } from 'apexcharts';
import Chart from 'react-apexcharts';

import { getDashboardInspectionTrendQueryOptions } from '@/queries/dashboard';

export const InspectionTrend = () => {
  const { data = { inspections: [], issues: [], categories: [] } } = useQuery(getDashboardInspectionTrendQueryOptions());

  const revenueOptions = {
    chart: {
      stacked: false,
      type: 'bar',
      toolbar: { show: false },
    },
    grid: {
      borderColor: '#ebe9f1',
      show: true,
      padding: {
        top: -20,
        bottom: -10,
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    xaxis: {
      categories: data.categories,
      labels: {
        // formatter: (val: any) => 'Day ' + val,
        show: false,
        style: {
          colors: '#b9b9c3',
          fontSize: '0.7525rem',
        },
      },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    colors: ['#5FC360', '#F99226'],
    plotOptions: {
      bar: {
        columnWidth: '50%',
        borderRadius: 3,
        borderRadiusWhenStacked: 'all',
        borderRadiusApplication: 'around',
      },
    },
    yaxis: {
      labels: {
        offsetX: -15,
        style: {
          colors: '#8299AE',
          fontSize: '12px',
        },
      },
    },
  } satisfies ApexOptions;

  return data !== null ? (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col">
        <div className="flex items-center justify-between">
          <span className="text-xl leading-[30px] font-medium">Inspections</span>
          <div className="flex gap-[20px]">
            <div className="flex items-center">
              <span className="bg-default-green mr-[5px] size-2 cursor-pointer rounded-full"></span>
              <span className="text-xs/[18px] font-normal">Inspections</span>
            </div>
            <div className="flex items-center">
              <span className="bg-default-orange mr-[5px] size-2 cursor-pointer rounded-full"></span>
              <span className="text-xs/[18px] font-normal">Issues</span>
            </div>
          </div>
        </div>
        <span className="text-secondary-text text-xs leading-[18px] font-normal">Last 30 days</span>
      </div>
      <Chart
        id="revenue-report-chart"
        type="bar"
        height="230"
        options={revenueOptions}
        series={[
          {
            name: 'Inspections',
            data: data.inspections,
          },
          {
            name: 'Issues',
            data: data.issues,
          },
        ]}
      />
    </div>
  ) : null;
};
